"use strict";

var _classCallCheck = require("/builds/Ayh8cDzT/0/mcfe/misrc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/Ayh8cDzT/0/mcfe/misrc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var resize_observer_lite_1 = require("resize-observer-lite");

var matchQueries_1 = require("container-query-toolkit/lib/matchQueries");

var isShallowEqual_1 = require("./isShallowEqual");

var ContainerQueryCore = /*#__PURE__*/function () {
  function ContainerQueryCore(query, callback) {
    var _this = this;

    _classCallCheck(this, ContainerQueryCore);

    this.result = {};
    this.rol = new resize_observer_lite_1.default(function (size) {
      var result = matchQueries_1.default(query)(size);

      if (!isShallowEqual_1.default(_this.result, result)) {
        callback(result);
        _this.result = result;
      }
    });
  }

  _createClass(ContainerQueryCore, [{
    key: "observe",
    value: function observe(element) {
      this.rol.observe(element);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.rol.disconnect();
    }
  }]);

  return ContainerQueryCore;
}();

exports.default = ContainerQueryCore;